import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const biopakCashbackViewRoute: RouteConfig<'with-page'> = {
    name: 'BioPak Cashback',
    path: '/rewards/biopak/cashback-deal',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['rewards'],
}